import React, { useEffect } from 'react';
import { useNavigate, Outlet, Navigate } from 'react-router-dom';

import { useRecoilValue } from 'recoil';
import { userState } from "../../recoil/atom";

const RootRoute = () => {
  const user = useRecoilValue(userState);
  const navigate = useNavigate();

  useEffect( () => {
    // console.log(user);
    if(user.institution_id!==1){
      navigate('/');
    }
  }, []);

  if(user.institution_id!==1){
    return <Navigate to="/" replace />
  }
  else{
    return <Outlet />;
  }
};

export default RootRoute;